import Seo from "@/components/Seo";

export default function NotFoundPage() {
        return (
                <div className="min-h-screen flex items-center px-6">
                        <Seo title="Page not found — Natant" description="This page doesn't exist." path="/404" noindex />
                        <div className="max-container w-full" data-testid="notfound-page">
                                <div className="step-eyebrow mb-5">404 · Lost between floors</div>
                                <h1 className="h2x text-4xl md:text-6xl max-w-[16ch] mb-6">
                                        This floor doesn&rsquo;t <span className="acc">exist</span>
                                </h1>
                                <p className="text-base md:text-lg text-[var(--bone-dim)] max-w-[48ch] mb-10 leading-relaxed">
                                        The page you were looking for isn&rsquo;t part of this building. Head back to the
                                        ground floor — the whole story starts there.
                                </p>
                                <div className="flex flex-wrap items-center gap-3">
                                        <a
                                                href="/"
                                                data-testid="notfound-home-link"
                                                className="pill-btn"
                                                style={{ background: "var(--accent-green)", borderColor: "var(--accent-green)", color: "#fff" }}
                                        >
                                                Back to the homepage →
                                        </a>
                                        <a href="/whitepaper" data-testid="notfound-whitepaper-link" className="pill-btn pill-btn--ghost">
                                                Read Whitepaper 01
                                        </a>
                                </div>
                        </div>
                </div>
        );
}
